export default "__VITE_ASSET__D89MuAV$__"